import defineComponent from 'flight';

function BiddingEvents() {

    this.defaultAttrs({
        initialState: false
    });

    this._sendBiddingEvents = function (evt, initData) {
        if (initData.pageSpecificData.biddingState) {
            this.trigger(document, 'analytics:track-event', {
                category: 'Bidding',
                action: 'Show',
                label: initData.pageSpecificData.biddingState,
                userTriggered: false
            });
        }
    };

    this.after('initialize', function () {
        this.on('data:navigation:after-modal-load', this._sendBiddingEvents);
        this.on('data:navigation:after-page-load', this._sendBiddingEvents);

        if (this.attr.initialState) {
            this.trigger(document, 'analytics:track-event', {
                category: 'Bidding',
                action: 'Show',
                label: this.attr.initialState,
                userTriggered: false
            });
        }
    });
}

module.exports = defineComponent.component(BiddingEvents);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/bidding-events.js